import type { FileFieldType } from '@Types/GF/Fields';

type Props = {
	field: FileFieldType;
	setFormValues: React.Dispatch<any>;
	formValues: any;
	errorMessage: string;
};

export default function FileField({ field, formValues, setFormValues, errorMessage }: Props) {
	const { id, formId, type, label, description, cssClass, isRequired } = field;
	const htmlId = `field_${formId}_${id}`;

	const updateValues = (files: any) => {
		const _form = { ...formValues };
		_form.values[`input_${id}`] = files?.[0]?.name;
		setFormValues(_form);
	};

	return (
		<div className={`gfield gfield-${type} ${cssClass}`.trim()}>
			{/* TODO VALUE */}

			{errorMessage && (
				<p className='mb-3 mt-1 text-base text-minos-form-error-color'>{errorMessage}</p>
			)}

			<div className={`peer relative cursor-pointer ${description ? 'mb-10' : 'mb-5'}`}>
				<div className='flex w-full flex-col items-center justify-center rounded-minos-form-input border-2 border-dashed border-minos-form-input-border-color bg-minos-form-input-bg-color p-10 '>
					<input
						type='file'
						className='sr-only disabled:cursor-not-allowed disabled:bg-minos-blue_dark-100 peer-focus:border-minos-form-input-border-color'
						name={String(id)}
						id={htmlId}
						required={Boolean(isRequired)}
						onChange={(e) => updateValues(e.target.files)}
					/>

					<label
						htmlFor={htmlId}
						className={`text-base text-minos-form-input-color ${
							isRequired &&
							'after:ml-0.5 after:font-semibold after:text-minos-form-require-color after:content-["*"]'
						} `}
					>
						{label}
					</label>
				</div>
				{description ? (
					<p className='minos-form-content-font-style mt-1 text-base tablet:minos-form-content-font-style'>
						{description}
					</p>
				) : null}
			</div>
		</div>
	);
}
